import { match } from 'ts-pattern'

import { Breadcrumbs as BreadcrumbsComponent } from './Breadcrumbs'

import { FullHeader } from './FullHeader'
import { SlimHeader } from './SlimHeader'
import type { HeaderProps } from './types'

function Header({
  type = 'full',
  slimMenuText = '',
  slimMenuURL = '',
  images,
  quoteWizard
}: HeaderProps) {
  return (
    <>
      {match(type)
        .with('slim', 'plain', 'plain-with-no-link', () => (
          <SlimHeader
            {...{ type, slimMenuText, slimMenuURL, images, quoteWizard }}
          />
        ))
        .with('full', () => <FullHeader {...{ images, quoteWizard }} />)
        .exhaustive()}
    </>
  )
}

// The `Breadcrumbs` component is being exported here to use it below the `Header` without
// caring about the Optimizely experiment. Once the experiment is finished, we'll add it to this component.
const Breadcrumbs = BreadcrumbsComponent

export { Header, Breadcrumbs }
